import styled from '@emotion/styled';
import { FC, useState } from 'react';
import { ICourse } from '@taleemabad/db';
import { BreakpointSizes, mq } from '@taleemabad/dsm/themes';
import { Menu, ProgressListCard, StyledDiv } from '@taleemabad/dsm/components';
import { useWindowSize } from '@taleemabad/shared';
import { TrainingStatus } from '@taleemabad/shared';
import { ProgressStatus } from '@taleemabad/db';

export interface CourseListProps {
  courses: ICourse[];
  isDownloadEnabled?: boolean;
  onCourseClick: (course: ICourse) => void;
  onDownload?: (course: ICourse) => void;
  onDownloadDelete?: (course: ICourse) => void;
}
const menuData = [
  { id: 1, name: 'Remove download', value: 'removeDownload', icon: 'delete' },
];
export const CourseList: FC<CourseListProps> = ({
  courses,
  isDownloadEnabled = false,
  onCourseClick,
  onDownload,
  onDownloadDelete,
}) => {
  const [width] = useWindowSize();
  const [openMenu, setOpenMenu] = useState<null | number>(null);

  const getCourseStatus = (percentage: number, id: number) => {
    if (getInProgressCourse && getInProgressCourse.id === id) {
      return TrainingStatus.InProgress;
    }
    if (percentage === 100) {
      return TrainingStatus.Completed;
    } else if (percentage > 0) {
      return TrainingStatus.InProgress;
    }
    return TrainingStatus.Locked;
  };
  const getInProgressCourse = courses.find(
    (course) =>
      course?.courseStatus === null ||
      course?.courseStatus === ProgressStatus.Pending ||
      course?.courseStatus === ProgressStatus.InProgress,
  );

  return (
    <CourseListContainer>
      {courses.map((course, index) => (
        <StyledDiv
          key={course.id}
          position="relative"
          width="100%"
          data-cy="teacher-training-courses-card"
        >
          <ProgressListCard
            progressPercentage={course?.courseCompletionPercentage}
            levelName={course.title}
            levelStatus={getCourseStatus(
              course?.courseCompletionPercentage,
              course.id,
            )}
            cardOnClick={() => onCourseClick(course)}
            bottomCardIcon="play_circle"
            bottomCardText={`${course.trainingsCount} Trainings`}
          />
          <Menu
            positioning="absolute"
            open={openMenu === course.id}
            menuCorner="end-end"
            anchorCorner="end-end"
            menuItems={menuData}
            xOffset={80}
            yOffset={-80}
            onSelectedItem={(item) => {
              setOpenMenu(null);
              if (item.value === 'removeDownload') {
                onDownloadDelete?.(course);
              }
            }}
            onClose={() => setOpenMenu(null)}
          />
        </StyledDiv>
      ))}
    </CourseListContainer>
  );
};

const CourseListContainer = styled.div`
  display: grid;
  gap: var(--rk-spacing-xl);
  grid-template-columns: repeat(4, 1fr);
  grid-column: 1 / -1;
  ${mq(BreakpointSizes.xs)} {
    grid-template-columns: repeat(1, auto);
  }
  ${mq(BreakpointSizes.sm)} {
    grid-template-columns: repeat(1, 1fr);
  }
  ${mq(BreakpointSizes.md)} {
    grid-template-columns: repeat(1, 1fr);
  }
  ${mq(BreakpointSizes.lg)} {
    grid-template-columns: repeat(2, 1fr);
  }
  ${mq(BreakpointSizes.xl)} {
    grid-template-columns: repeat(3, 1fr);
  }
`;
